import { computed } from 'vue';

type CaptionItemProps = {
    caption?: string;
};

export const CaptionItemAppSetup = (props: CaptionItemProps) => {
    const hashtagLinksText = computed(() => {
        if ((props.caption || '').length === 0) {
            return '';
        }

        const hashtagRegex = /#((?:[^#])*)/g;
        const replacedStr = (props.caption || '').replace(/\([^()]*\)/g, '').replace(hashtagRegex, match => {
            return `<span class='hast-tag' style="color: grey;">${match}</span>`;
        });

        return replacedStr;
    });

    return {
        hashtagLinksText,
    };
};
